<template>
  <div class="is-narrow bimplus-sidemenu-container bimplus-side-menu is-relative">
    <aside class="menu"> 
      <ul class="menu-list"> 
        <li @click="setProjectModelActive">
          <a class="is-clearfix is-flex is-align-items-center active">
             <i class="icon-modelprojectnavigator"></i>
          </a>
        </li>
        <li>
          <a class="is-clearfix is-flex is-align-items-center" :class="showCameraOptions ? 'active' : ''">
            <i class="icon-modelcamera" @click="toggleCameraOptions"></i>
            <div v-if="showCameraOptions" class="camera-setting is-flex is-justify-content-space-between">
              <i class="icon-modelcamerafront" @click="setFrontView"></i>
              <i class="icon-modelcameratop" @click="setTopView"></i>
              <i class="icon-modelcameraside" @click="setSideView"></i>
              <i class="icon-modelcameraperspective" @click="setPerspectiveView"></i>
            </div>
          </a>
        </li>
        <li>
          <a class="is-clearfix is-flex is-align-items-center">
            <i class="icon-modelcamerareset" @click="setResetView"></i>
          </a>          
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
import {reactive, onBeforeMount, toRefs, onMounted} from 'vue';
import bimplusViewer from '../../views/bimplus/bimplusViewer';

export default {
  name: 'ViewerSideMenu',

  setup(props, {emit}) {
    const data = reactive ({
      showCameraOptions: false
    });

    const toggleCameraOptions = () => {
      data.showCameraOptions = !data.showCameraOptions;
    };

    const setFrontView = () => {
      bimplusViewer.frontView();
    };

    const setTopView = () => {
      bimplusViewer.topView();
    };

    const setSideView = () => {
      bimplusViewer.sideView();
    };

    const setPerspectiveView = () => {
      bimplusViewer.perspectiveView();
    };

    const setResetView = () => {
      bimplusViewer.resetView();
    };

    const setProjectModelActive = () => {
      emit('setProjectModelActive');
    }

    return {
      ...toRefs(data),
      toggleCameraOptions,
      setFrontView,
      setTopView,
      setSideView,
      setPerspectiveView,
      setResetView,
      setProjectModelActive
    }
  },
};

</script>